/**
 * i18next setup.
 *
 * Translations are bundled rather than fetched: there are two languages and the
 * files are small, so shipping them avoids a flash of untranslated text on first
 * paint -- which in an RTL locale would also mean a visible layout flip.
 */

import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { normalizeLanguage, useLanguageStore } from '@/stores/languageStore'
import type { Language } from '@/types/api'

import ar from './locales/ar.json'
import en from './locales/en.json'

export const resources = {
  en: { translation: en },
  ar: { translation: ar },
} as const

/**
 * The language to start in: a previous explicit choice, otherwise the browser's
 * preference, otherwise English.
 */
const initialLanguage = (): Language => {
  const stored = useLanguageStore.getState().language
  if (stored) return stored
  const browser = typeof navigator !== 'undefined' ? navigator.language : 'en'
  return normalizeLanguage(browser)
}

void i18next.use(initReactI18next).init({
  resources,
  lng: initialLanguage(),
  fallbackLng: 'en',
  supportedLngs: ['en', 'ar'],
  interpolation: {
    // React escapes for us; double-escaping would mangle Arabic punctuation.
    escapeValue: false,
  },
  returnNull: false,
})

export default i18next
